// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,json_types=true"
// @generated from file bundles/v1/real_estate.proto (package bundles.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Money, MoneyJson } from "../../google/type/money_pb";
import { file_google_type_money } from "../../google/type/money_pb";
import type { PostalAddress, PostalAddressJson } from "../../google/type/postal_address_pb";
import { file_google_type_postal_address } from "../../google/type/postal_address_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bundles/v1/real_estate.proto.
 */
export const file_bundles_v1_real_estate: GenFile =
	/*@__PURE__*/
	fileDesc(
		"ChxidW5kbGVzL3YxL3JlYWxfZXN0YXRlLnByb3RvEgpidW5kbGVzLnYxImAKDlJlYWxFc3RhdGVEYXRhEigKB2xpc3RpbmcYASABKAsyFy5idW5kbGVzLnYxLkxpc3RpbmdEYXRhEiQKBWFnZW50GAIgASgLMhUuYnVuZGxlcy52MS5BZ2VudERhdGEiwgQKC0xpc3RpbmdEYXRhEg4KBm1sc19pZBgBIAEoCRILCgN1cmwYAiABKAkSDgoGYWN0aXZlGAMgASgIEisKB2FkZHJlc3MYBCABKAsyGi5nb29nbGUudHlwZS5Qb3N0YWxBZGRyZXNzEhUKDXByb3BlcnR5X3R5cGUYBSABKAkSEwoLZGVzY3JpcHRpb24YBiABKAkSFQoIYmVkcm9vbXMYByABKAVIAIgBARIaCgliYXRocm9vbXMYCCABKAVCAhgBSAGIAQESHAoPdG90YWxfYmF0aHJvb21zGBAgASgCSAKIAQESGwoOZnVsbF9iYXRocm9vbXMYCSABKAVIA4gBARIbCg5oYWxmX2JhdGhyb29tcxgKIAEoBUgEiAEBEhgKC2xpdmluZ19hcmVhGAsgASgFSAWIAQESFQoIbG90X3NpemUYESABKAVIBogBARIhCgVwcmljZRgMIAEoCzISLmdvb2dsZS50eXBlLk1vbmV5Eg4KBnBob3RvcxgNIAMoCRIaChJhZGRpdGlvbmFsX2RldGFpbHMYDiABKAkSMAoMbGlzdGluZ19kYXRlGA8gASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEILCglfYmVkcm9vbXNCDAoKX2JhdGhyb29tc0ISChBfdG90YWxfYmF0aHJvb21zQhEKD19mdWxsX2JhdGhyb29tc0IRCg9faGFsZl9iYXRocm9vbXNCDgoMX2xpdmluZ19hcmVhQgsKCV9sb3Rfc2l6ZSJICgZPZmZpY2USEQoJYnJva2VyYWdlGAEgASgJEisKB2FkZHJlc3MYAiABKAsyGi5nb29nbGUudHlwZS5Qb3N0YWxBZGRyZXNzIsIBCglBZ2VudERhdGESEgoKZmlyc3RfbmFtZRgBIAEoCRIRCglsYXN0X25hbWUYAiABKAkSIgoGb2ZmaWNlGAMgASgLMhIuYnVuZGxlcy52MS5PZmZpY2USDQoFZW1haWwYBCABKAkSGwoTbW9iaWxlX3Bob25lX251bWJlchgFIAEoCRIbChNvZmZpY2VfcGhvbmVfbnVtYmVyGAYgASgJEhIKCmZheF9udW1iZXIYByABKAkSDQoFcGhvdG8YCCABKAliBnByb3RvMw",
		[file_google_protobuf_timestamp, file_google_type_money, file_google_type_postal_address],
	);

/**
 * @generated from message bundles.v1.RealEstateData
 */
export type RealEstateData = Message<"bundles.v1.RealEstateData"> & {
	/**
	 * @generated from field: bundles.v1.ListingData listing = 1;
	 */
	listing?: ListingData | undefined;

	/**
	 * @generated from field: bundles.v1.AgentData agent = 2;
	 */
	agent?: AgentData | undefined;
};

/**
 * @generated from message bundles.v1.RealEstateData
 */
export type RealEstateDataJson = {
	/**
	 * @generated from field: bundles.v1.ListingData listing = 1;
	 */
	listing?: ListingDataJson;

	/**
	 * @generated from field: bundles.v1.AgentData agent = 2;
	 */
	agent?: AgentDataJson;
};

/**
 * Describes the message bundles.v1.RealEstateData.
 * Use `create(RealEstateDataSchema)` to create a new message.
 */
export const RealEstateDataSchema: GenMessage<RealEstateData, { jsonType: RealEstateDataJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_real_estate, 0);

/**
 * ListingData is a message that represents a real estate listing.
 *
 * @generated from message bundles.v1.ListingData
 */
export type ListingData = Message<"bundles.v1.ListingData"> & {
	/**
	 * The MLS ID of the listing
	 *
	 * @generated from field: string mls_id = 1;
	 */
	mlsId: string;

	/**
	 * URL of the original listing
	 *
	 * @generated from field: string url = 2;
	 */
	url: string;

	/**
	 * Active is a boolean to determine if the listing is currently active.
	 *
	 * @generated from field: bool active = 3;
	 */
	active: boolean;

	/**
	 * Address is the postal address of the listing.
	 *
	 * @generated from field: google.type.PostalAddress address = 4;
	 */
	address?: PostalAddress | undefined;

	/**
	 * @generated from field: string property_type = 5;
	 */
	propertyType: string;

	/**
	 * @generated from field: string description = 6;
	 */
	description: string;

	/**
	 * @generated from field: optional int32 bedrooms = 7;
	 */
	bedrooms?: number | undefined;

	/**
	 * @deprecated in favor of float total_bathrooms
	 *
	 * @generated from field: optional int32 bathrooms = 8 [deprecated = true];
	 * @deprecated
	 */
	bathrooms?: number | undefined;

	/**
	 * @generated from field: optional float total_bathrooms = 16;
	 */
	totalBathrooms?: number | undefined;

	/**
	 * @generated from field: optional int32 full_bathrooms = 9;
	 */
	fullBathrooms?: number | undefined;

	/**
	 * @generated from field: optional int32 half_bathrooms = 10;
	 */
	halfBathrooms?: number | undefined;

	/**
	 * @generated from field: optional int32 living_area = 11;
	 */
	livingArea?: number | undefined;

	/**
	 * @generated from field: optional int32 lot_size = 17;
	 */
	lotSize?: number | undefined;

	/**
	 * @generated from field: google.type.Money price = 12;
	 */
	price?: Money | undefined;

	/**
	 * @generated from field: repeated string photos = 13;
	 */
	photos: string[];

	/**
	 * @generated from field: string additional_details = 14;
	 */
	additionalDetails: string;

	/**
	 * @generated from field: google.protobuf.Timestamp listing_date = 15;
	 */
	listingDate?: Timestamp | undefined;
};

/**
 * ListingData is a message that represents a real estate listing.
 *
 * @generated from message bundles.v1.ListingData
 */
export type ListingDataJson = {
	/**
	 * The MLS ID of the listing
	 *
	 * @generated from field: string mls_id = 1;
	 */
	mlsId?: string;

	/**
	 * URL of the original listing
	 *
	 * @generated from field: string url = 2;
	 */
	url?: string;

	/**
	 * Active is a boolean to determine if the listing is currently active.
	 *
	 * @generated from field: bool active = 3;
	 */
	active?: boolean;

	/**
	 * Address is the postal address of the listing.
	 *
	 * @generated from field: google.type.PostalAddress address = 4;
	 */
	address?: PostalAddressJson;

	/**
	 * @generated from field: string property_type = 5;
	 */
	propertyType?: string;

	/**
	 * @generated from field: string description = 6;
	 */
	description?: string;

	/**
	 * @generated from field: optional int32 bedrooms = 7;
	 */
	bedrooms?: number;

	/**
	 * @deprecated in favor of float total_bathrooms
	 *
	 * @generated from field: optional int32 bathrooms = 8 [deprecated = true];
	 * @deprecated
	 */
	bathrooms?: number;

	/**
	 * @generated from field: optional float total_bathrooms = 16;
	 */
	totalBathrooms?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: optional int32 full_bathrooms = 9;
	 */
	fullBathrooms?: number;

	/**
	 * @generated from field: optional int32 half_bathrooms = 10;
	 */
	halfBathrooms?: number;

	/**
	 * @generated from field: optional int32 living_area = 11;
	 */
	livingArea?: number;

	/**
	 * @generated from field: optional int32 lot_size = 17;
	 */
	lotSize?: number;

	/**
	 * @generated from field: google.type.Money price = 12;
	 */
	price?: MoneyJson;

	/**
	 * @generated from field: repeated string photos = 13;
	 */
	photos?: string[];

	/**
	 * @generated from field: string additional_details = 14;
	 */
	additionalDetails?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp listing_date = 15;
	 */
	listingDate?: TimestampJson;
};

/**
 * Describes the message bundles.v1.ListingData.
 * Use `create(ListingDataSchema)` to create a new message.
 */
export const ListingDataSchema: GenMessage<ListingData, { jsonType: ListingDataJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_real_estate, 1);

/**
 * @generated from message bundles.v1.Office
 */
export type Office = Message<"bundles.v1.Office"> & {
	/**
	 * @generated from field: string brokerage = 1;
	 */
	brokerage: string;

	/**
	 * @generated from field: google.type.PostalAddress address = 2;
	 */
	address?: PostalAddress | undefined;
};

/**
 * @generated from message bundles.v1.Office
 */
export type OfficeJson = {
	/**
	 * @generated from field: string brokerage = 1;
	 */
	brokerage?: string;

	/**
	 * @generated from field: google.type.PostalAddress address = 2;
	 */
	address?: PostalAddressJson;
};

/**
 * Describes the message bundles.v1.Office.
 * Use `create(OfficeSchema)` to create a new message.
 */
export const OfficeSchema: GenMessage<Office, { jsonType: OfficeJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_real_estate, 2);

/**
 * @generated from message bundles.v1.AgentData
 */
export type AgentData = Message<"bundles.v1.AgentData"> & {
	/**
	 * @generated from field: string first_name = 1;
	 */
	firstName: string;

	/**
	 * @generated from field: string last_name = 2;
	 */
	lastName: string;

	/**
	 * @generated from field: bundles.v1.Office office = 3;
	 */
	office?: Office | undefined;

	/**
	 * @generated from field: string email = 4;
	 */
	email: string;

	/**
	 * @generated from field: string mobile_phone_number = 5;
	 */
	mobilePhoneNumber: string;

	/**
	 * @generated from field: string office_phone_number = 6;
	 */
	officePhoneNumber: string;

	/**
	 * @generated from field: string fax_number = 7;
	 */
	faxNumber: string;

	/**
	 * @generated from field: string photo = 8;
	 */
	photo: string;
};

/**
 * @generated from message bundles.v1.AgentData
 */
export type AgentDataJson = {
	/**
	 * @generated from field: string first_name = 1;
	 */
	firstName?: string;

	/**
	 * @generated from field: string last_name = 2;
	 */
	lastName?: string;

	/**
	 * @generated from field: bundles.v1.Office office = 3;
	 */
	office?: OfficeJson;

	/**
	 * @generated from field: string email = 4;
	 */
	email?: string;

	/**
	 * @generated from field: string mobile_phone_number = 5;
	 */
	mobilePhoneNumber?: string;

	/**
	 * @generated from field: string office_phone_number = 6;
	 */
	officePhoneNumber?: string;

	/**
	 * @generated from field: string fax_number = 7;
	 */
	faxNumber?: string;

	/**
	 * @generated from field: string photo = 8;
	 */
	photo?: string;
};

/**
 * Describes the message bundles.v1.AgentData.
 * Use `create(AgentDataSchema)` to create a new message.
 */
export const AgentDataSchema: GenMessage<AgentData, { jsonType: AgentDataJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_real_estate, 3);
